export default "__VITE_ASSET__CPCCp0s4__"